import PropTypes from "prop-types";
import { FormControl, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ErrorLabel, FieldLabel } from "./Labels";

const useStyles = makeStyles(theme => ({
  formControl: {
    marginBottom: 5,
    "& .MuiInputLabel-shrink": {
      fontSize: 12,
      top: 10,
    },
    "& .MuiOutlinedInput-root": {
      paddingBottom: 0,
      paddingRight: 0,
    },
    "& .MuiOutlinedInput-input": {
      paddingBottom: 2,
    },
  },
}));

const InputField = ({
  description,
  displayName,
  error,
  fieldName,
  isRequired,
  maxRows,
  minRows,
  multiline,
  onChange,
  value,
}) => {
  const classes = useStyles();

  const haveError = !!error?.error;

  return (
    <FormControl className={classes.formControl} fullWidth>
      <FieldLabel
        description={description.replace("[", "").replace("]", "")}
        displayName={displayName}
        error={haveError}
        fieldName={fieldName}
        //isRequired={isRequired}
        shrink
        value={value}
      />
      <TextField
        //error={haveError}
        name={fieldName}
        placeholder={displayName}
        required={isRequired}
        maxRows={maxRows}
        minRows={minRows}
        multiline={multiline}
        onChange={onChange}
        shrink
        value={value}
        InputProps={{
          endAdornment:
            <ErrorLabel show={haveError} />
        }}
      />
    </FormControl>
  );
};

InputField.defaultProps = {
  description: "",
  displayName: null,
  error: null,
  isRequired: false,
};

InputField.propTypes = {
  description: PropTypes.string,
  displayName: PropTypes.string,
  error: PropTypes.shape({
    error: PropTypes.bool,
  }),
  fieldName: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default InputField;
